import { useEffect, useState, useRef, useCallback } from 'react';

const GOOGLE_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

function useGoogleLogin({ clientId, onSuccess, onError }) {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [codeClient, setCodeClient] = useState(null);

  const onSuccessRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);

  useEffect(() => {
    onSuccessRef.current = onSuccess;
    onErrorRef.current = onError;
  }, [onSuccess, onError]);

  useEffect(() => {
    if (window.google && window.google.accounts && window.google.accounts.oauth2) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = GOOGLE_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => setScriptLoaded(true);
    script.onerror = () => {
      if (onErrorRef.current) {
        onErrorRef.current(new Error('Falha ao carregar script do Google'));
      }
    };

    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (!scriptLoaded) return;

    const client = window.google.accounts.oauth2.initCodeClient({
      client_id: clientId,
      scope: 'openid email profile',
      ux_mode: 'popup',
      callback: (response) => {
        if (response.code) {
          if (onSuccessRef.current) onSuccessRef.current(response.code);
        } else {
          if (onErrorRef.current) {
            onErrorRef.current(new Error('Código de autorização não retornado pelo Google'));
          }
        }
      },
      error_callback: (error) => {
        if (onErrorRef.current) onErrorRef.current(error);
      },
    });

    setCodeClient(client);
  }, [scriptLoaded, clientId]);

  const login = useCallback(() => {
    if (!codeClient) return;
    codeClient.requestCode();
  }, [codeClient]);

  return { login, isReady: scriptLoaded };
}

export default useGoogleLogin;



// WEBPACK FOOTER //
// ./src/hooks/useGoogleLogin.js